/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>

module DealerwareWebContent {

    "use strict";

    export class SettingsExpensesController {

        public static $inject : string[ ] = [

        ];

        public modal: any;

        constructor(

        ) {

        }
    }

    getDealerwareWebContentModule().controller(
        'SettingsExpensesController', SettingsExpensesController
    );
}
